export class ReportData {
	progress: number;
	remainingSeconds?: number;
	fileID?: number;
	fileName: string;
}

export interface CheckImportFilesResponse {
    status: string;
}